import React from 'react';
import { gql } from '@soundxyz/gql-string';
import type { FragmentType } from '@graphql/reactQuery';
import { getFragment, ReleasesAddedListFragmentDoc } from '@graphql/reactQuery';
import { RELEASE_PLAYLIST_ACTION_TYPE, ReleasesPlaylistList } from './Playlist/ReleasesPlaylist';

/*#__PURE__*/ gql(/* GraphQL */ `
  fragment ReleasesAddedList on ReleasesAddedToPlaylist {
    id
    date
    numAddedReleases
    playlist {
      id
      ...PlaylistActivityInfo
    }
    user {
      id
      ...MinimalUser
    }
    addedReleases(pagination: { first: 3 }) {
      edges {
        node {
          id
          ...ReleasePill
        }
      }
    }
  }
`);

export const ReleasesAddedList = ({
  activityFrag,
  playlistFeed,
}: {
  activityFrag: FragmentType<ReleasesAddedListFragmentDoc>;
  playlistFeed: boolean;
}) => {
  const {
    id: actionId,
    playlist,
    addedReleases,
    numAddedReleases,
    user,
    date,
  } = getFragment(ReleasesAddedListFragmentDoc, activityFrag);

  if (!playlist) {
    return null;
  }

  return (
    <ReleasesPlaylistList
      actionId={actionId}
      userFrag={user}
      playlistFrag={playlist}
      featuredReleases={addedReleases.edges.map(v => v.node)}
      isoDateString={date}
      releaseCount={numAddedReleases}
      actionType={RELEASE_PLAYLIST_ACTION_TYPE.RELEASE_ADDED}
      playlistFeed={playlistFeed}
    />
  );
};
